function addFooterSignature() {
  const footerBottom = document.querySelector(".footer-bottom");

  if (footerBottom) {
    const signature = footerBottom.querySelector("#signature");
    if (signature) {
      const mirandaMediaLink = `Vytvořila
            <a class="company" href="https://www.mirandamedia.cz/" target="_blank">
              MirandaMedia Group s.r.o.
            </a>
                 <img class="company__logo" alt="Logo MirandaMedia" src="https://713766.myshoptet.com/user/documents/upload/miranda.svg">

          `;

      const shoptetPlatformText = `na platformě 
          <a href="https://www.shoptet.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" class="image" target="_blank">
            <img src="https://cdn.myshoptet.com/prj/dist/master/cms/img/common/logo/shoptetLogo.svg" width="17" height="17" alt="Shoptet" class="vam" loading="lazy">
         <Shoptet href="https://www.shoptet.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" class="title" target="_blank">Shoptet</a>
            </a>
          
        `;

      signature.innerHTML = "";
      signature.insertAdjacentHTML(
        "beforeend",
        mirandaMediaLink + shoptetPlatformText
      );
    }
  }
}

function handlePaymentFooter() {
  const paymentFooter = document.querySelector(".custom-footer__banner10 ");
  const footerBottom = document.querySelector(".footer-bottom");
  const copyright = document.querySelector(".copyright");

  if (paymentFooter && footerBottom && copyright) {
    copyright.insertAdjacentElement("beforebegin", paymentFooter);
  }
}

handlePaymentFooter();

// ! Instagram
function instaSwiper() {
  console.log("Instagram swiper initialized");
  let swiperInstance = null;
  const instagramWidget = document.querySelector(".instagram-widget");
  const allLinks = instagramWidget.querySelectorAll("a");
  const newsItems = Array.from(allLinks).filter(
    (a) => !a.closest(".instagram-follow-btn")
  );

  const createSwiperStructure = () => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-wrapper");

    newsItems.forEach((item) => {
      item.classList.add("swiper-slide");
      wrapper.appendChild(item);
    });

    instagramWidget.innerHTML = "";
    instagramWidget.classList.add("swiper");
    instagramWidget.appendChild(wrapper);

    const pagination = document.createElement("div");
    pagination.className = "swiper-pagination";
    instagramWidget.appendChild(pagination);
  };

  const destroySwiperStructure = () => {
    instagramWidget.innerHTML = "";
    instagramWidget.classList.remove("swiper");

    newsItems.forEach((item) => {
      item.classList.remove("swiper-slide");
      instagramWidget.appendChild(item);
    });
  };

  const initSwiper = () => {
    if (!swiperInstance) {
      swiperInstance = new Swiper(".instagram-widget", {
        slidesPerView: 3,
        spaceBetween: 16,
        pagination: {
          el: `.instagram-widget .swiper-pagination`,
          clickable: true,
        },
        observer: true,
        observeParents: true,
        breakpoints: {
          640: {
            slidesPerView: 4,
          },
          770: {
            slidesPerView: 5,
          },
        },
      });
    }
  };

  const destroySwiper = () => {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  };

  const instaBtn = document.querySelector(".instagram-follow-btn");
  const title = document.querySelector(".instagram-wrapper h4");
  if (title) {
    const checkScreenSize = () => {
      if (window.innerWidth < 1221) {
        if (!instagramWidget.classList.contains("swiper")) {
          createSwiperStructure();
          initSwiper();
        }
        instagramWidget.insertAdjacentElement("afterend", instaBtn);
      } else {
        if (instagramWidget.classList.contains("swiper")) {
          destroySwiper();
          destroySwiperStructure();
        }
        title?.appendChild(instaBtn);
      }
    };

    window.addEventListener("resize", checkScreenSize);
    checkScreenSize();
  }
}

function waitForInstagramBtn(callback) {
  const interval = setInterval(() => {
    const instagramBtn = document.querySelector(
      ".instagram-widget .instagram-follow-btn"
    );
    if (instagramBtn) {
      clearInterval(interval);
      callback(instagramBtn);
    }
  }, 100);
}

// ===============================
// Add Instagram Block to Footer
// ===============================
function addInstagramBlock(instagramBtn) {
  const instagram = document.querySelector(".custom-footer__instagram");
  if (instagram) {
    const instaHeadingText = "Sledujte nás na Instagramu";
    const instaLinkText = "Informujeme o akcích, slevách a soutěžích";

    const instaBtn = "Sledovat @kings.cz";

    const btn = document.querySelector(".instagram-follow-btn span a");
    btn.textContent = instaBtn;
    const instaWrapper = document.createElement("section");
    instaWrapper.classList.add("instagram-wrapper", "container");

    const instaHeading = document.createElement("h4");
    instaHeading.textContent = instaHeadingText;

    const instaLink = document.createElement("span");
    instaLink.classList.add("insta-link");
    instaLink.textContent = instaLinkText;

    instaHeading.append(instaLink);
    instaWrapper.append(instaHeading, instagram);

    if (instagramBtn) {
      instaHeading.appendChild(instagramBtn);
    }

    const footer = document.querySelector("#footer");
    if (footer) {
      footer.insertAdjacentElement("beforebegin", instaWrapper);
    }
  }
  console.log("Instagram block added to footer");
  instaSwiper();
}

export { addFooterSignature, waitForInstagramBtn, addInstagramBlock };
